import { DatadogRegistration } from "@p0security/integrations-datadog-shared";
import type { DatadogComponents } from "@p0security/integrations-datadog-shared";
import { Install } from "@p0security/integrations-installer";
import type { InstallProps } from "@p0security/integrations-installer";

import { datadogInstaller } from "./install";

export const Datadog = (
  props: Pick<
    InstallProps<typeof DatadogComponents>,
    "cardOverride" | "onInstall" | "siblings"
  >
) => (
  <Install<typeof DatadogComponents>
    installer={datadogInstaller}
    integration="datadog"
    registration={DatadogRegistration}
    {...props}
  />
);
